import { createAkiliApi } from '../../utils/api/api-methods'

/*
  GET /v1/claim/{token}/preview — public, no auth token.

  200 - { status, practice_name, clinician_name }
  404 - { code: 'not_found', message } (also returned for a malformed token)

  createAkiliApi camel-cases the response, so practice_name -> practiceName.
*/

export type ClaimPreviewStatus = 'ready' | 'claimed' | 'expired' | 'refunded'

type RequestData = {
  token: string
}

type ErrorResponse = {
  success: false
  // undefined/null when the request never reached the server (network error, timeout)
  status: 400 | 404 | 500 | 502 | 503 | number | null | undefined
  localizedErrorMessage: string | null
  requestParams: RequestData
  responsePayload: {
    code?: string
    message?: string
  }
}

type SuccessResponse = {
  success: true
  status: 200
  requestParams: RequestData
  responsePayload: {
    status: ClaimPreviewStatus
    practiceName: string
    clinicianName?: string | null
  }
}

export type ClaimPreviewResponse = ErrorResponse | SuccessResponse

const name = 'getClaimPreview'

const getClaimPreviewAPI = (token: string): Promise<ClaimPreviewResponse> => {
  const url = `claim/${encodeURIComponent(token)}/preview`

  return createAkiliApi(null, url, 'GET', name)
}

export default getClaimPreviewAPI
